<template>
    <div class="content">

      <div style="text-align: center;">
         <el-button type="warning" @click="paymentBtn">微信/支付宝支付</el-button>
         <br>
         <br><br><br><br>
         <el-button type="danger" @click="paymentType">USDT支付</el-button>
         <br>
         <br><br><br><br>
         <el-button type="primary" @click="stripPay">信用卡支付</el-button>
      </div>
     
    

    </div>
</template>
<script>
import {Form, Message} from 'element-ui';
  export default {
    data() {
      return {
        payBtn:false,
        server_name:'',
        ruleForm:{
          serviceId:'',
          service_id:'',
          game_account_name:'',
          agin_game_account_name:'',
          amt:0
        }
      };
    },
    created(){
        let self = this;
        var url = window.location.href ;             //获取当前url
        var cs={};
        if(url.indexOf('#') > -1 && url.indexOf('?') > -1 &&  url.indexOf('&') > -1){ 
            var dz_url = url.split('#')[0];                //获取#/之前的字符串
            var csstr = dz_url.split('?')[1];                //获取?之后的参数字符串
            var cs_arr = csstr.split('&');                    //参数字符串分割为数组
       
            for(var i=0;i<cs_arr.length;i++){         //遍历数组，拿到json对象
              if(cs_arr[i]){
                if(cs_arr[i].split('=')){
                  cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1] 
                }
              }
            }
        }
    
        if(cs.service_id){ 
           //这样就拿到了参数中的数据
            self.ruleForm.serviceId = cs.service_id;   
     
        }else{
            self.ruleForm.serviceId = '44f714b60a064f738b1dd56a9c16ad4c'
        }
        self.ruleForm.service_id = self.ruleForm.serviceId;    
        this.getParam();
    },
    methods: {
      stripPay(){
        console.log("stripPay");
         this.$router.push({path:'/Strippay',query:{service_id:this.ruleForm.serviceId}}); // 编程式导航到/about路由
      },
      paymentType(){
        //  window.open(this.out_pay_url, "_blank");
        this.$router.push({path:'/Upay',query:{service_id:this.ruleForm.serviceId}}); // 编程式导航到/about路由
       // window.open(`/Upay?service_id=${this.ruleForm.serviceId}`);
       // window.location.href= "http://app.sxzbd.com/pay/tbNg";
      },
      paymentBtn(){
        window.open(this.out_pay_url, "_blank");
      },
      getParam(){
          let self = this;
  
        console.log("this.ruleForm.service_id:"+self.ruleForm.service_id);

        self.postRequest('/game/servers_detail',self.ruleForm).then(resp =>{
                 if(resp.err >= 500){
                    Message.error({message: resp.msg});
                    return;
                 }
                 self.serverDetail = resp.data;
                self.out_pay_url = resp.data.out_pay_url;
                self.scale = resp.data.scale;
                document.title = resp.data.service_name;
                self.server_name = resp.data.service_name;
            })

       

      },
     
    },
  }
</script>
<style scoped>
    .title-class{
        padding-left: 140px;
        padding-top: 30px;
    }
    .get-role{
        margin-left: 10px;
    }
    .content{
        margin: 0 auto;
        margin-top: 50px;
        align-content: center;
        width: 50%;
        height: 600px;
        max-height: 800px;
        background-color: rgb(161, 194, 203);
        border-radius: 20px;
    }
    .form-class{
        padding-top: 20px;
        padding-left: 90px;
        width: 60%;
    }

</style>